<script setup lang="ts">
const props = defineProps<{
  buttonText: string;
}>();
</script>

<template>
  <div :class="$style.advertising__wrapper">
    <div :class="$style.advertising__wrapper__information">
      <div :class="$style.advertising__wrapper__block">
        <div :class="$style.advertising__wrapper__name">Почта</div>
        <div :class="$style.advertising__wrapper__link">
          <Icon name="my-icon:i-mail" size="20px"></Icon>
          <a href="mailto:sales@cre.ru" class="advertising__wrapper__mail">
            sales@cre.ru
          </a>
        </div>
      </div>
      <div :class="$style.advertising__wrapper__block">
        <div :class="$style.advertising__wrapper__name">Телефон</div>
        <div :class="$style.advertising__wrapper__link">
          <Icon name="my-icon:i-call" size="20px"></Icon>
          <a href="tel:+74950858818">+7 (495) 085-88-18</a>
        </div>
      </div>
    </div>
    <div :class="$style.advertising__wrapper__action">
      {{ props.buttonText }}
    </div>
  </div>
</template>

<style module lang="scss">
.advertising__wrapper {
  display: flex;
  flex-direction: row-reverse;
  background: var(--color-gray-bg);

  &__information {
    width: 50%;
    display: flex;
    flex-direction: column;
  }

  &__block {
    padding: var(--space-2-5x);
  }

  &__block:first-child {
    border-bottom: 1px solid var(--color-gray-line);
  }

  &__name {
    @include text_caption1_caps;
    color: var(--color-gray-text);
    margin-bottom: var(--space-0-5x);
  }

  &__link {
    display: flex;
    align-items: center;
    gap: var(--space-1x);
    a {
      @include text_caption1_caps;
      text-decoration: none;
      color: var(--color-red-1);
    }

    path {
      fill: var(--color-red-1);
    }
  }

  &__action {
    padding: var(--space-2-5x);
    display: flex;
    align-items: center;
    width: 50%;
    @include text_body1_medium;
    color: var(--color-black-1);
    border-right: 1px solid var(--color-gray-line);
  }

  &_button {
    width: 100%;
    background: var(--color-black-1);
    display: flex;
    align-items: center;
    justify-content: center;
    @include text_button1;
    height: 60px;
    color: var(--color-white);
  }
}

@media (max-width: 768px) {
  .advertising__wrapper {
    flex-direction: column-reverse;
    &__information {
      width: 100%;
    }

    &__action {
      width: 100%;
      border-bottom: 1px solid var(--color-gray-line);
    }
  }
}
</style>
